import React, { Component } from "react";
import { connect } from "react-redux";
import { formValueSelector, Field } from "redux-form";
import { isEmpty } from "lodash";
import AutoComplete from "../../../../../../components/form/AutoComplete";
import Input from "../../../../../../components/form/Input";
import IcoInput from "../../../../../../components/form/IcoInput";
import CheckBox from "../../../../../../components/form/Checkbox";
import CroField from "../../../generalForm/CroField";
import CroCountry from "../../../generalForm/CroCountry";
import CroMunicipality from "../../../generalForm/CroMunicipality";
import {
  CroAddButton,
  CroRemoveButton,
} from "../../../generalForm/CroIconButtons";
import { fieldsRemove, notForPublic } from "../../../../CroUtils";
import { Source } from "../../../../enum";
import * as V from "../../../../../../utils/formValidation";
import H from "../../../../helpEnum";
import Help from "../../../Help";
import { ItemNumber } from "./itemRenumber";
import { change } from "redux-form";

class OtherContracts extends Component {

  addItem = () => {
    const { fields } = this.props;
    fields.push({ itemOrder: fields.length + 1 });
  };

  removeItem = (index) => {
    const { fields, dispatch, selector } = this.props;
    const arrayName = fields.name;
    const current = selector(arrayName) || [];
    const next = current
        .filter((_, i) => i !== index)
        .map((item, idx) => ({ ...item, itemOrder: idx + 1 }));
    dispatch(change("statementForm", arrayName, next));
  };

  componentDidMount() {
    const { change, fields } = this.props;

    fields.map((item, index, sources) => {
      if (
        sources.get(index).sourceType === undefined &&
        !isEmpty(sources.get(index).firstName)
      ) {
        return change(`${item}.sourceType`, Source.PERSON);
      }
      if (
        sources.get(index).sourceType === undefined &&
        !isEmpty(sources.get(index).name)
      ) {
        return change(`${item}.sourceType`, Source.LEGAL_PERSON);
      }
      return null;
    });
  }

  onSourceCheckOtherContracts = (field, value, f) => () => {
    const { change } = this.props;
    change(field, value);
    change(f, "");
  };

  render() {
    const {
      meta: { submitFailed },
      fields,
      disabled,
      noPublicLogged,
      dos,
      t,
      defaultCountry,
      isLogged,
      isPublicStatement,
      auth,
      outgoing,
      ongoing,
      onICOChange,
      aresErrors,
      versionChangedClass
    } = this.props;
    return (
      <div className="cro-array-container">
        {fields.map((item, index, sources) => {
          const checkboxLabelStyle =
            submitFailed && !sources.get(index).sourceType
              ? { color: "red" }
              : {};
          const personValue =
            sources.get(index).sourceType === undefined
              ? !isEmpty(sources.get(index).firstName)
              : sources.get(index).sourceType === Source.PERSON;
          const legalPersonValue =
            sources.get(index).sourceType === undefined
              ? !isEmpty(sources.get(index).name)
              : sources.get(index).sourceType === Source.LEGAL_PERSON;
          return (
            <div key={index} className={`cro-array-item ${versionChangedClass ? versionChangedClass(item) : ""}`}>
              <ItemNumber index={index} />
              {!disabled && fields.length > 1 && (
                  <CroRemoveButton onClick={() => this.removeItem(index)} />
              )}
              <div className="cro-array-item-content">
                <div className="statementForm__arrayGrid">
                  <div className="statementForm__arrayFull">
                    <CroField
                      className={versionChangedClass ? versionChangedClass(`${item}.type`) : ""}
                      title="Druh činnosti"
                      name={`${item}.type`}
                      component={AutoComplete}
                      fullWidth
                      disabled={disabled}
                      url="/api/ciselniky/typ-cinnosti"
                      validate={[V.required, V.isDictionary]}
                      helpEnum={H[`${t}OC_TYPE`].r}
                    />
                  </div>

                  {(!dos || (dos && (outgoing || ongoing))) &&
                    noPublicLogged && (
                      <div className="statementForm__arrayFull">
                        <CroField
                          className={versionChangedClass ? versionChangedClass(`${item}.specification`) : ""}
                          title="Specifikace"
                          name={`${item}.specification`}
                          component={Input}
                          fullWidth
                          disabled={disabled}
                          maxlen={1000}
                        />
                      </div>
                    )}

                  {!dos && (
                    <>
                      <div className="statementForm__arrayFull">
                        <div className="checkbox-row">
                          <Field
                            className={versionChangedClass ? versionChangedClass(`${item}.sourceType`) : ""}
                            name={`${item}.sourceType`}
                            component={Input}
                            type="hidden"
                            style={{ display: "none" }}
                            validate={[V.required]}
                          />
                          <div className="checkbox">
                            <label className="title" style={checkboxLabelStyle}>
                              Zaměstnavatel - nepodnikající fyzická osoba
                            </label>
                            <CheckBox
                              value={personValue}
                              onChange={this.onSourceCheckOtherContracts(
                                `${item}.sourceType`,
                                Source.PERSON,
                                `${item}.name`,
                              )}
                              disabled={disabled}
                              aria-label="Zaměstnavatel - nepodnikající fyzická osoba"
                            />
                          </div>
                          <div className="checkbox">
                            <label className="title" style={checkboxLabelStyle}>
                              Zaměstnavatel - podnikající fyzická osoba nebo
                              právnická osoba
                            </label>
                            <CheckBox
                              value={legalPersonValue}
                              onChange={this.onSourceCheckOtherContracts(
                                `${item}.sourceType`,
                                Source.LEGAL_PERSON,
                                `${item}.firstName`,
                              )}
                              disabled={disabled}
                              aria-label="Zaměstnavatel - podnikající fyzická osoba nebo právnická osoba"
                            />
                          </div>
                        </div>
                      </div>

                      {personValue && (
                        <div className="statementForm__arrayFull">
                          <div className="statementForm__arrayGrid statementForm__arrayGrid--3col">
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.firstName`) : ""}
                              title="Jméno"
                              name={`${item}.firstName`}
                              component={Input}
                              disabled={disabled}
                              validate={[
                                V.required,
                                V.textSpaceDashOnly,
                                V.noSpaceStartEnd,
                              ]}
                              helpEnum={H[`${t}OC_FIRST_NAME`].r}
                            />
                            {notForPublic(isPublicStatement, auth) && (
                              <CroField 
                                className={versionChangedClass ? versionChangedClass(`${item}.middleName`) : ""}
                                title="Další jména"
                                name={`${item}.middleName`}
                                component={Input}
                                disabled={disabled}
                              />
                            )}
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.lastName`) : ""}
                              title="Příjmení"
                              name={`${item}.lastName`}
                              component={Input}
                              disabled={disabled}
                              validate={[
                                V.required,
                                V.textSpaceDashOnly,
                                V.noSpaceStartEnd,
                              ]}
                              helpEnum={H[`${t}OC_LAST_NAME`].r}
                            />
                          </div>
                        </div>
                      )}

                      {legalPersonValue && (
                        <div className="statementForm__arrayFull">
                          <div className="statementForm__arrayGrid">
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.name`) : ""}
                              title="Jméno/název"
                              name={`${item}.name`}
                              component={Input}
                              disabled={disabled}
                              validate={[V.required]}
                              helpEnum={H[`${t}OC_LEGAL_PERSON_NAME`].r}
                            />
                            <div>
                              <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.identificationNumber`) : ""}
                                title="IČO"
                                name={`${item}.identificationNumber`}
                                component={IcoInput}
                                disabled={disabled}
                                validate={[V.required, V.isNumeric]}
                                helpEnum={H[`${t}OC_IDENTIFICATION_NUMBER`].r}
                                onICOChange={(val) => onICOChange && onICOChange(index, val)}
                              />
                              {aresErrors && aresErrors[index] && (
                                <span className="cro-ares-error">{aresErrors[index]}</span>
                              )}
                            </div>

                            <p className="statementForm__arrayLabel">
                              Místo výkonu podnikání/sídlo právnické osoby{" "}
                              <Help
                                helpEnum={H[`${t}OC_ADDRESS`].r}
                                disabled={disabled}
                              />
                            </p>

                            <CroCountry
                              className={versionChangedClass ? versionChangedClass(`${item}.address.country`) : ""}
                              title="Stát"
                              name={`${item}.address`}
                              disabled={disabled}
                              form="statementForm"
                              validate={[V.required]}
                              defaultCountry={defaultCountry}
                            />
                            <CroMunicipality
                              className={versionChangedClass ? versionChangedClass(`${item}.address.municipality`) : ""}
                              title="Obec"
                              name={`${item}.address`}
                              disabled={disabled}
                              form="statementForm"
                              validate={[V.required]}
                            />
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.address.street`) : ""}
                              title="Ulice"
                              name={`${item}.address.street`}
                              component={Input}
                              disabled={disabled}
                              validate={[V.required]}
                            />
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.address.orientationNumber`) : ""}
                              title="Č.p./Č.o."
                              name={`${item}.address.orientationNumber`}
                              component={Input}
                              disabled={disabled}
                              validate={[V.required]}
                              helpEnum={H.HOUSE_NUMBER.r}
                            />
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.address.zip`) : ""}
                              title="PSČ"
                              name={`${item}.address.zip`}
                              component={Input}
                              disabled={disabled}
                              validate={[V.required]}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  {dos && (
                    <div className="statementForm__arrayFull">
                      <div className="statementForm__arrayGrid">
                        <CroField
                          className={versionChangedClass ? versionChangedClass(`${item}.name`) : ""}
                          title="Obchodní firma/název"
                          name={`${item}.name`}
                          component={Input}
                          disabled={disabled}
                          validate={[V.required]}
                          helpEnum={H[`${t}OC_LEGAL_PERSON_NAME`].r}
                        />
                        <div>
                          <CroField
                            className={versionChangedClass ? versionChangedClass(`${item}.identificationNumber`) : ""}
                            title="IČO"
                            name={`${item}.identificationNumber`}
                            component={IcoInput}
                            disabled={disabled}
                            validate={[V.required, V.isNumeric]}
                            helpEnum={H[`${t}OC_IDENTIFICATION_NUMBER`].r}
                            onICOChange={(val) => onICOChange && onICOChange(index, val)}
                          />
                          {aresErrors && aresErrors[index] && (
                            <span className="cro-ares-error">{aresErrors[index]}</span>
                          )}
                        </div>

                        {isLogged && (
                          <p className="statementForm__arrayLabel">
                            Sídlo právnické osoby{" "}
                            <Help
                              helpEnum={H[`${t}OC_ADDRESS`].r}
                              disabled={disabled}
                            />
                          </p>
                        )}
                        {isLogged && (
                          <CroCountry
                            className={versionChangedClass ? versionChangedClass(`${item}.address.country`) : ""}
                            title="Stát"
                            name={`${item}.address`}
                            disabled={disabled}
                            form="statementForm"
                            validate={[V.required]}
                          />
                        )}
                        {isLogged && (
                          <CroMunicipality
                            className={versionChangedClass ? versionChangedClass(`${item}.address.municipality`) : ""}
                            title="Obec"
                            name={`${item}.address`}
                            disabled={disabled}
                            form="statementForm"
                            validate={[V.required]}
                          />
                        )}
                        {isLogged && (
                          <CroField
                            className={versionChangedClass ? versionChangedClass(`${item}.address.street`) : ""}
                            title="Ulice"
                            name={`${item}.address.street`}
                            component={Input}
                            disabled={disabled}
                            validate={[V.required]}
                          />
                        )}
                        {isLogged && (
                          <CroField
                            className={versionChangedClass ? versionChangedClass(`${item}.address.orientationNumber`) : ""}
                            title="Č.p./Č.o."
                            name={`${item}.address.orientationNumber`}
                            component={Input}
                            disabled={disabled}
                            validate={[V.required]}
                            helpEnum={H.HOUSE_NUMBER.r}
                          />
                        )}
                        {isLogged && (
                          <CroField
                            className={versionChangedClass ? versionChangedClass(`${item}.address.zip`) : ""}
                            title="PSČ"
                            name={`${item}.address.zip`}
                            component={Input}
                            disabled={disabled}
                            validate={[V.required]}
                          />
                        )}
                      </div>
                    </div>
                  )}

                  {noPublicLogged && (
                    <div className="statementForm__arrayFull">
                      <CroField
                        className={versionChangedClass ? versionChangedClass(`${item}.note`) : ""}
                        title="Poznámka"
                        name={`${item}.note`}
                        component={Input}
                        fullWidth
                        disabled={disabled}
                        multiline
                        helpEnum={H[`${t}OC_NOTE`].r}
                        maxlen={1000}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
        {!disabled && (
          <div className="cro-array-add">
            <CroAddButton onClick={this.addItem} />
            <Help helpEnum={H.ADD_REMOVE_OC.r} />
          </div>
        )}
      </div>
    );
  }
}

export default connect((state, props) => ({
  selector: (select) => formValueSelector("statementForm")(state, select),
}))(OtherContracts);
